import { motion } from "motion/react";
import type React from "react";
import { createPortal } from "react-dom";

import { twResolve } from "@/helpers/tw-resolve";

import { overlayVariants } from "./variants";

interface OverlayProps {
  withPortal?: boolean;
  onClick?: () => void;
}

export function Overlay({ withPortal, onClick }: OverlayProps): React.ReactNode {
  const Component = (
    <motion.div
      className={twResolve(
        "fixed top-0 left-0 z-backdrop h-dvh w-screen bg-background-default-inverse/60",
        onClick && "cursor-pointer",
      )}
      variants={overlayVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
      key="overlay"
      {...{ onClick }}
    />
  );

  if (withPortal) {
    return createPortal(Component, document.body);
  }

  return Component;
}
